<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex justify-content-end m-1" *ngIf="!labField.length && !isProcessing">
    <div class="d-flex gap-3">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openAddFieldPopup()" (keydown.enter)="openAddFieldPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add Field(s) </span>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end m-1 freeze-buttons" *ngIf="labField.length && !isFrozen && !isProcessing">
    <div class="d-flex gap-3">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="update()"
            (keydown.enter)="update()">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Update</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openAddFieldPopup()" (keydown.enter)="openAddFieldPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add Field(s)</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openDeletePopup()"
            (keydown.enter)="openDeletePopup()">
            <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
            <span class="reload_text text-white">Delete Field(s)</span>
        </div>
        <span *ngIf="false" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReorderPopup()" (keydown.enter)="openReorderPopup()" matTooltip="Reorder">
            <img src="../../../assets/img/reorder.svg" width="18px" height="18px" alt="reorder" />
            <span class="reload_text text-white">Reorder</span>
        </span>
    </div>
</div>

<div class="row" *ngIf="!isProcessing">
    <div class="category">
        <mat-tab-group [(selectedIndex)]="selectedPhaseTabIndex" (selectedTabChange)="onTabChanged($event);">
            <mat-tab *ngFor="let phase of phases;">
                <ng-template mat-tab-label>
                    <span> {{phase.phaseName}}</span>
                </ng-template>
                <mat-tab-group *ngIf="labField.length && !isProcessing">
                    <mat-tab *ngFor="let category of categories;">
                        <ng-template mat-tab-label>
                            <span> {{category.categoryName}}</span>
                        </ng-template>
                        <div class="row" style="padding-top: 10px;">
                            <div [ngClass]="getColWidth(field.questionTypeCode)"
                                *ngFor="let field of getFieldsByCategory(category.categoryName)">
                                <label id="category-name" for="email">{{ field.question }}</label>
                                <ng-container [ngSwitch]="field.questionTypeCode">

                                    <!-- Text Field -->
                                    <input *ngSwitchCase="'Text Field'" class="form-control"
                                        [(ngModel)]="field.response" [disabled]="isFrozen"
                                        (ngModelChange)="changeDetected()" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">

                                    <!-- Date Field -->
                                    <input *ngSwitchCase="'Date Field'" type="text"
                                        class="form-control data-picker-continer" bsDatepicker
                                        [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses"
                                        [(ngModel)]="field.response" (bsValueChange)="changeDetected()"
                                        [disabled]="isFrozen" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">

                                    <!-- Large Text -->
                                    <textarea *ngSwitchCase="'Large Text'" class="form-control" rows="4"
                                        [(ngModel)]="field.response" (ngModelChange)="changeDetected()"
                                        [disabled]="isFrozen" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip"></textarea>

                                    <!-- Drop Down -->
                                    <mat-select *ngSwitchCase="'Drop Down'" [(ngModel)]="field.response"
                                        [disabled]="isFrozen" (selectionChange)="changeDetected()" placeholder="Select"
                                        (closed)="dropDownSearchText=''" (click)="focusSearch('search')"
                                        (keydown.enter)="focusSearch('search')" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
                                        <input matInput type="search" [(ngModel)]="dropDownSearchText"
                                            class="dropdownsearchstyle" placeholder="Search">
                                        <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                                        <mat-option
                                            *ngFor="let item of field.questionValues | assessmentSearch : dropDownSearchText"
                                            [value]="item">{{ item }}</mat-option>
                                    </mat-select>

                                    <!-- Multiselect Drop Down -->
                                    <mat-select *ngSwitchCase="'Multiselect Drop Down'" multiple #multiselect
                                        [attr.data-field-id]="field.questionId" [(ngModel)]="field.dd"
                                        [disabled]="isFrozen" (selectionChange)="changeDetected()" placeholder="Select"
                                        (closed)="dropDownSearchText=''" (click)="focusSearch('flexifieldValueSearch')"
                                        (keydown.enter)="focusSearch('flexifieldValueSearch')"
                                        [matTooltip]="field.instructions" matTooltipPosition="below"
                                        [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
                                        matTooltipClass="custom-tooltip">
                                        <input matInput type="search" [(ngModel)]="dropDownSearchText"
                                            placeholder="Search" class="dropdownsearchstyle">
                                        <div class="select-all">
                                            <mat-checkbox [(ngModel)]="field.multiSelection" [disabled]="isFrozen"
                                                (change)="toggleAllSelection('multiselect', field); changeDetected()">
                                                Select All
                                            </mat-checkbox>
                                        </div>
                                        <mat-option (onSelectionChange)="onMultiSelect($event, field); changeDetected()"
                                            *ngFor="let q of field.questionValues | assessmentSearch : dropDownSearchText"
                                            [value]="q">
                                            {{ q }}
                                        </mat-option>
                                    </mat-select>

                                    <!-- Vertical Radio Button -->
                                    <mat-radio-group *ngSwitchCase="'Vertical Radio Button'"
                                        [(ngModel)]="field.response" [disabled]="isFrozen" (change)="changeDetected()"
                                        class="d-flex flex-column" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
                                        <mat-radio-button *ngFor="let val of field.questionValues" [value]="val">
                                            {{ val }}
                                        </mat-radio-button>
                                    </mat-radio-group>

                                    <!-- Horizontal Radio Button -->
                                    <mat-radio-group *ngSwitchCase="'Horizontal Radio Button'"
                                        [(ngModel)]="field.response" [disabled]="isFrozen" (change)="changeDetected()"
                                        class="d-inline-flex" [matTooltip]="field.instructions"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
                                        <mat-radio-button *ngFor="let val of field.questionValues" [value]="val">
                                            {{ val }}
                                        </mat-radio-button>
                                    </mat-radio-group>

                                    <!-- Vertical Checkbox Button -->
                                    <ng-container *ngSwitchCase="'Vertical Checkbox Button'"
                                        [matTooltip]="field.instructions" matTooltipPosition="below"
                                        [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
                                        matTooltipClass="custom-tooltip">
                                        <section *ngFor="let val of field.questionValues" class="d-flex flex-column">
                                            <mat-checkbox
                                                (change)="onCheckboxChange($event, val, field); changeDetected()"
                                                [checked]="field.dd.indexOf(val) !== -1" [disabled]="isFrozen">
                                                {{ val }}
                                            </mat-checkbox>
                                        </section>
                                    </ng-container>

                                    <!-- Horizontal Checkbox Button -->
                                    <ng-container *ngSwitchCase="'Horizontal Checkbox Button'"
                                        [matTooltip]="field.instructions" matTooltipPosition="below"
                                        [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
                                        matTooltipClass="custom-tooltip" style="align-items: center;">
                                        <section *ngFor="let val of field.questionValues" class="d-inline-flex">
                                            <mat-checkbox [checked]="field.dd.indexOf(val) !== -1" [disabled]="isFrozen"
                                                (change)="onCheckboxChange($event, val, field); changeDetected()">
                                                {{ val }}
                                            </mat-checkbox>
                                        </section>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<ng-template #addPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeAddFieldPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{popupTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;">

        <div class="col-md-12" style="margin: 3px;">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedOption">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let list of criteriaList"
                    [value]="list" (change)="onPrimaryOptionChange($event)">
                    {{list}}
                </mat-radio-button>
            </mat-radio-group>
        </div> <br>

        <div *ngIf="selectedOption == 'Choose from Template'">
            <div class="col-md-5">
                <label id="template-name" for="email">Select Template</label>&nbsp;
                <mat-select matInput multiple placeholder="Select" #templateRef [(ngModel)]="template"
                    (closed)="templateSearchText=''" (click)="focusSearch('focus-template')"
                    (keydown.enter)="focusSearch('focus-template')">
                    <input type="search" id="focus-template" class="dropdownsearchstyle"
                        [(ngModel)]="templateSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="templateSelection" (change)="toggleAllSelection('template', 0)">
                            Select All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of templateDropDown | multiAssessmentSearchPipe : templateSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onTemplateSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div *ngIf="selectedOption == 'Add Manually'">
            <div class="col-md-5" style="margin: 3px;">
                <label id="category" for="email">Select Category :</label>&nbsp;
                <mat-select matInput placeholder="Select" [(ngModel)]="category" (closed)="categorySearchText = ''"
                    (click)="focusSearch('template-focus')" (keydown.enter)="focusSearch('emplate-focus')">
                    <input type="search" id="temaplate-focus" class="dropdownsearchstyle"
                        [(ngModel)]="categorySearchText" matInput placeholder="Search">
                    <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onCategorySelect($event,null);">Un-select</mat-option>
                    <mat-option *ngFor="let item of categoryList | assessmentSearch :categorySearchText"
                        (onSelectionChange)="onCategorySelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div> <br>
            <fieldset class="border p-2 fieldsetStyle" *ngIf="category">
                <legend class="float-none w-auto p-2">
                    <div class="" style="font-size: 14px;color: #cfcfcf;">Field Details</div>
                </legend>
                <div class="row">
                    <div
                        [ngClass]="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field' ? 'col-md-4' : 'col-md-3'">
                        <div>
                            <!-- Field Name  -->
                            <label id="field-name" for="email">Field Name</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="field.fieldName"
                            (ngModelChange)="onNgModelChange($event,'field-name')">
                    </div>

                    <div
                        [ngClass]="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field' ? 'col-md-4' : 'col-md-3'">
                        <div>
                            <!-- Sub Department -->
                            <label id="field-type" for="email">Field Type Code</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldTypeCode"
                            (closed)="fieldTypeSearchText=''" (keydown.enter)="focusSearch('type-focus')"
                            (click)="focusSearch('type-focus')">
                            <input type="search" id="type-focus" class="dropdownsearchstyle"
                                [(ngModel)]="fieldTypeSearchText" matInput placeholder="Search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onFieldTypeSelect($event,null);">Un-select</mat-option>
                            <mat-option *ngFor="let item of fieldTypeDropDown | assessmentSearch :fieldTypeSearchText"
                                (onSelectionChange)="onFieldTypeSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-md-4"
                        *ngIf="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field'">
                        <div>
                            <!-- Field Name  -->
                            <label id="field-values" for="email">Field Values</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <input class="input-filed-continers" type="text" [(ngModel)]="field.fieldValues"
                            (ngModelChange)="onNgModelChange($event,'field-values')">
                    </div>


                    <div class="col-md-6">
                        <div>
                            <!-- Instructions -->
                            <label for="email">Instructions</label>
                        </div>
                        <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                            [(ngModel)]="field.instructions"></textarea>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions
            *ngIf="selectedOption && (template || category)">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addFromTemplate()" (keydown.enter)="addFromTemplate()"
                *ngIf="selectedOption == 'Choose from Template'">
                <img src=" ../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add Fields</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addManually(field)" (keydown.enter)="addManually()" *ngIf="selectedOption == 'Add Manually'">
                <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add Field</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="closeAddFieldPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeDeletePopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Delete </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;">

        <div class="col-md-12" style="margin: 3px;">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedOption">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let list of criteriaList"
                    [value]="list" (change)="onDeletionOptionChange($event)">
                    {{list}}
                </mat-radio-button>
            </mat-radio-group>
        </div> <br>

        <div class="row" *ngIf="selectedOption">
            <div class=" col-md-6" *ngIf="selectedOption=='Delete By Category'">
                <label id="delete-category" for="email">Select Category :</label>&nbsp;
                <mat-select matInput placeholder="Select" [(ngModel)]="category" (closed)="categorySearchText = ''"
                    (click)="focusSearch('category-focus')" (keydown.enter)="focusSearch('category-focus')">
                    <input type="search" id="category-focus" class="dropdownsearchstyle"
                        [(ngModel)]="categorySearchText" matInput placeholder="Search">
                    <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onDeleteCategorySelect($event,null);">Un-select</mat-option>
                    <mat-option *ngFor="let item of categoryList | assessmentSearch :categorySearchText"
                        (onSelectionChange)="onDeleteCategorySelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-6">
                <div>
                    <label id="delete-reason" for="email">Reason for Delete</label>
                    <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                    [(ngModel)]="deleteReason"></textarea>
            </div>
        </div>

        <div *ngIf="selectedOption=='Delete By Category'">
            <fieldset class="border p-2 fieldsetStyle" *ngIf="category">
                <legend class="float-none w-auto p-2">
                    <div class="" style="font-size: 14px;color: #cfcfcf;">Fields</div>
                </legend>
                <div class="table-container" style="align-items : center;">
                    <table style="max-height: 40vh;" *ngIf="category">
                        <thead>
                            <th style="min-width: 60px; text-align: center;">
                                <div style="display: flex;">
                                    <div>
                                        <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                    <div style="margin-left: 5px;">
                                        <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox"
                                            (change)="onParentCheckBoxChanged($event)">
                                    </div>
                                </div>
                            </th>
                            <th class="control-text" style="width: 240px; text-align: center;">
                                <span> Field </span>
                                <span class="grid-header-container"> </span>
                            </th>
                            <th class="control-text" style="width: 240px; text-align: left;">
                                <span> Field Type </span>
                                <span class="grid-header-container"> </span>
                            </th>
                            <th class="control-text" style="width: 150px; text-align: left;">
                                <span> Instructions </span>
                                <span class="grid-header-container"></span>
                            </th>
                        </thead>
                        <tbody>
                            <tr *ngFor=" let field of getFieldsByCategory(category); let idx=index;">
                                <td style="min-width: 80px; text-align: center;">
                                    <div style="display: flex;">
                                        <div [ngClass]="field.childCheckBox ?'static_icon':'hover-menu-icons'">
                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                        </div>
                                        <div style="margin-left: 5px;">
                                            <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                                [checked]="field.childCheckBox"
                                                (change)="onChildCheckBoxChanged($event, field, idx)">
                                        </div>
                                    </div>
                                </td>
                                <td class="control-text" style="width: 240px; text-align: center;">
                                    <span> {{ field.question }} </span>
                                </td>
                                <td class="control-text" style="text-align: left;">
                                    <span> {{ field.questionTypeCode }} </span>
                                </td>
                                <td class="control-text" style="text-align: left;">
                                    <span> {{ field.instructions }} </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions
            *ngIf="deleteReason && (selectedOption === 'Delete All' || (selectedOption === 'Delete By Category' && tempArray.length && category))">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="deleteMethod()"
                (keydown.enter)="deleteMethod()">
                <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
                <span class="reload_text text-white">{{selectedOption=='Delete All' ? 'Delete All' : 'Delete'}}</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="closeDeletePopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #reorderPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReorder()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{popupTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;">
        <div class="criteria"
            *ngIf="!(selectedCriteria == 'Reorder Category' || (selectedCriteria == 'Reorder Fields' && selectedCategory) )">
            <div class="col-md-5">
                <label for="email">Choose an option to reorder</label>&nbsp;
                <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedCriteria">
                    <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let criteria of criteriaList"
                        [value]="criteria" (change)="onSearchCriteriaChanged(criteria)">
                        {{criteria}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="col-md-5" *ngIf="selectedCriteria == 'Reorder Fields'">
                <label for="email">Select Category</label>&nbsp;
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedCategory"
                    (closed)="categorySearchText=''" (click)="focusSearch('focus-category')"
                    (keydown.enter)="focusSearch('focus-category')">
                    <input type="search" id="focus-category" class="dropdownsearchstyle"
                        [(ngModel)]="categorySearchText" matInput placeholder="search">
                    <mat-option *ngFor="let item of categoryDropDown | assessmentSearch : categorySearchText"
                        [value]="item.valueExp" (onSelectionChange)="onCategoryReorderSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="reorder"
            *ngIf="selectedCriteria == 'Reorder Category' || (selectedCriteria == 'Reorder Fields' && selectedCategory) ">
            <b class="align-center">
                Drag and drop to reorder the {{ selectedCriteria == 'Reorder Category' ? 'Categories' : 'Fields' }}
            </b>
            <div class="table-container">
                <table style="max-height: 65vh;">
                    <thead>
                        <th class="control-text" style="width: 240px; text-align: center;">
                            <span>
                                {{ selectedCriteria == 'Reorder Category' ? 'Category Order' : 'Field Order' }}
                            </span>
                            <span class="grid-header-container"> </span>
                        </th>
                        <th class="control-text" style="width: 240px; text-align: left;">
                            <span>
                                {{ selectedCriteria == 'Reorder Category' ? 'Category Name' : 'Field Name' }}
                            </span>
                            <span class="grid-header-container"> </span>
                        </th>
                        <th class="control-text" style="width: 150px; text-align: left;">
                            <span>New Order</span>
                            <span class="grid-header-container"></span>
                        </th>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
                        <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let i of grid let idx = index;">
                            <td class="control-text" style="width: 240px; text-align: center;">
                                <span>
                                    {{ selectedCriteria == 'Reorder Category' ? i.categorySeq : i.fieldSeq }}
                                </span>
                            </td>
                            <td class="control-text" style="text-align: left;">
                                <span>
                                    {{ selectedCriteria == 'Reorder Category' ? i.categoryName : i.fieldName }}
                                </span>
                            </td>
                            <td class="control-text" style="text-align: left;">
                                <span>{{i.newSeq}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="reorderItems()" [disabled]="!isReordered">
                <i class="fa fa-save"></i> Reorder
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReorder()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #resultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelResultPopup()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Field Result(s) </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Field</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
                        <td class="row-data">
                            <!--Is commented for later debugging {{isAdding}} -->
                            {{ isAdding ? r.field.fieldName : r.field.question }}
                        </td>
                        <td class="row-data"
                            [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.response.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>